module.exports = __webpack_public_path__ + "static/media/loseLarge30_1.2fb37b58.svg";